import Swal from 'sweetalert2'

const SwalMessage = ({ iSsuccess, ...props }) => {

  return Swal.fire({
    position: 'bottom-end',
    reverseButtons: true,
    icon: iSsuccess ? 'success' : 'error',
    title: props?.title ? props?.title : "تغییرات با موفقیت اعمال شد",
    showConfirmButton: false,
    timer: 2000,
    focusConfirm: true,
    willOpen: () => {
      Swal.getPopup().focus()
    },
    ...props
  });
}

export default SwalMessage;